import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["as", "itemAs", "children", "display", "alignItem"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import styled, { css } from 'styled-components';
import { getSpacing, getPropNamesFromPropDefinition, getPropFilter } from 'utils/ui';
import { positionProps, positionPropsDef, sizeProps, sizePropsDef, textProps, textPropsDef } from 'styles/styleProps';
import { jsx as _jsx } from "react/jsx-runtime";
var stylePropNames = getPropNamesFromPropDefinition([].concat(_toConsumableArray(positionPropsDef), _toConsumableArray(sizePropsDef), _toConsumableArray(textPropsDef)));
var shouldForwardProp = getPropFilter(['align', 'spacing', 'splitBy'].concat(_toConsumableArray(stylePropNames)));

// const getSpacingFromTheme = p => getSpacing(p.spacing, p.theme);
var getSpacingFromTheme = function getSpacingFromTheme(p) {
  var val = getSpacing(p.spacing, p.theme);
  return val !== undefined ? String(val) : '0';
};
var Item = styled.li.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'display' && prop !== 'alignItem';
  }
}).withConfig({
  displayName: "InlineList__Item",
  componentId: "sc-1cp0odj-0"
})(["display:", ";max-width:100%;", ""], function (p) {
  return p.display || 'inline-block';
}, function (p) {
  return p.display === 'inline-flex' && p.alignItem ? "align-items: ".concat(p.alignItem, ";") : '';
});
var Wrapper = styled('ul').withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "InlineList__Wrapper",
  componentId: "sc-1cp0odj-1"
})(["", " list-style:none;margin:0;padding:0;min-width:0;", " ", " ", " & > ", "{vertical-align:", ";", " ", " ", "}"], positionProps, function (p) {
  return p.spacing && css(["margin-left:-", ";margin-bottom:-", ";"], getSpacingFromTheme(p), getSpacingFromTheme(p));
}, sizeProps, textProps, Item, function (p) {
  return p.align || 'top';
}, function (p) {
  return p.spacing && css(["padding-left:", ";padding-bottom:", ";"], getSpacingFromTheme(p), getSpacingFromTheme(p));
}, function (p) {
  return p.splitBy === 'comma' && css(["&:not(:last-of-type)::after{content:',';margin-right:0.3em;}"]);
}, function (p) {
  return p.splitBy === 'dot' && css(["&:not(:last-of-type)::after{content:'\xB7';display:inline-block;vertical-align:middle;margin:-0.15em 1ch 0;font-weight:bold;}"]);
});
var InlineList = function InlineList(_ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'ul' : _ref$as,
    _ref$itemAs = _ref.itemAs,
    itemAs = _ref$itemAs === void 0 ? 'li' : _ref$itemAs,
    children = _ref.children,
    display = _ref.display,
    alignItem = _ref.alignItem,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Wrapper, _objectSpread(_objectSpread({
    as: as
  }, otherProps), {}, {
    children: React.Children.map(children, function (child, i) {
      if (child) {
        return /*#__PURE__*/_jsx(Item, {
          as: itemAs,
          display: display,
          alignItem: alignItem,
          children: child
        }, i);
      }
    })
  }));
};
InlineList.Wrapper = Wrapper;
InlineList.Item = Item;
export default InlineList;